import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GerarCobrancaService } from '../../../../../shared/services/apis/orquestrador-financas/gerar-cobranca.service';
import { GerarCobrancaResponse } from '../../../../../shared/services/responses/orquestrador-financas/gerar-cobranca.response';
import { CanalCobrancaEnum } from '../../../../../shared/enums/financas/canal-cobranca.enum';

export interface GerarCobrancaDialogData {
    idContasReceberParcela: number;
    descricao: string;
}

@Component({
    selector: 'app-gerar-cobranca-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
    templateUrl: './gerar-cobranca-dialog.component.html',
    styleUrl: './gerar-cobranca-dialog.component.css'
})
export class GerarCobrancaDialogComponent implements OnInit {

    public isLoading = true;
    public resultado: GerarCobrancaResponse | null = null;
    public copiado = false;

    get isBoleto(): boolean { return this.resultado?.canal === CanalCobrancaEnum.Boleto; }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: GerarCobrancaDialogData,
        public dialogRef: MatDialogRef<GerarCobrancaDialogComponent>,
        private gerarCobrancaService: GerarCobrancaService
    ) { }

    ngOnInit(): void {
        this.gerarCobrancaService.gerarCobranca(this.data.idContasReceberParcela).subscribe({
            next: (res: GerarCobrancaResponse) => {
                this.isLoading = false;
                this.resultado = res;
            },
            error: () => {
                this.isLoading = false;
                this.resultado = Object.assign(new GerarCobrancaResponse(), {
                    isError: true,
                    errorDescription: 'Não foi possível gerar a cobrança.'
                });
            }
        });
    }

    public copiarLinhaDigitavel(): void {
        navigator.clipboard.writeText(this.resultado?.linhaDigitavel ?? '');
        this.copiado = true;
        setTimeout(() => (this.copiado = false), 2000);
    }

    // Fecha. Se ainda está gerando, deixa rodando em segundo plano (não sinaliza sucesso/refresh);
    // se já terminou, sinaliza para o caller atualizar a lista.
    public fechar(): void {
        this.dialogRef.close(this.isLoading ? undefined : { sucesso: !this.resultado?.isError });
    }
}
